import Header from '../components/Header';
import BookCard from '../components/BookCard';
import { bookCatalog } from '../data/books';

export default function BooksPage() {
  return (
    <>
      <Header />
      <main className="mx-auto max-w-6xl space-y-7 px-4 py-8 sm:px-6">
        <section className="max-w-5xl border-l-4 border-brand-cyan bg-white/85 p-6 shadow-xl shadow-slate-200/60 sm:p-7">
          <p className="text-sm font-semibold uppercase tracking-[0.25em] text-brand-cyan">
            Books
          </p>
          <h1 className="mt-3 text-3xl font-semibold leading-tight text-slate-900 md:text-[2.4rem]">
            Prism Puzzles books
          </h1>
          <p className="mt-3 max-w-3xl text-sm leading-7 text-slate-600 md:text-base">
            Browse the current lineup. Titles with purchase pages link to Amazon.
          </p>
        </section>

        <div className="grid grid-cols-1 justify-items-center gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {bookCatalog.map((book) => (
            <BookCard key={book.id} book={book} />
          ))}
        </div>
      </main>
    </>
  );
}
